import React, { useEffect } from 'react';
import { getBaseUrl } from '../../common/common';
import { useCallCenterFlag, useLoading } from '../../hooks/order';
import { routesConfig } from '../../util/util';
import { useTranslation } from 'react-i18next';
import { useCartData } from '../../hooks/order';
const Footer = () => {
  const { t } = useTranslation();
  const { spanishLanguagePref } = useCartData();
  const { loading, scheduleLoading } = useLoading();
  const { showCallNow } = useCallCenterFlag();
  const pathname = '/' + window.location.href.substring(window.location.href.lastIndexOf('/') + 1)
  const showFooter = pathname.includes(routesConfig.products) || pathname.includes(routesConfig.vasPage) || pathname.includes(routesConfig.checkout) || pathname.includes('servRef');
  useEffect(() => {
    if (loading) {
      document.body.classList.add('body-loading');
    } else {
      document.body.classList.remove('body-loading');
    }
  }, [loading])
  return (
    <>
      <footer className={`${loading || scheduleLoading ? 'without-fixed-footer' : ''}`} style={showFooter && !showCallNow ? { marginTop: '0px' } : {}}>
        <div className="elink-container">
          <div className="d-flex j-between al-center">
            <div>&copy; {new Date().getFullYear()} EarthLink, LLC · {t('footer.allRightsReserved')}</div>
            <div>
              <a href={getBaseUrl() + (spanishLanguagePref ? 'tcs/privacy-policy-spanish/' : 'tcs/privacy-policy/')}>{t('footer.privacyPolicy')}</a> · <a href={getBaseUrl() + 'tcs/interest-based-ads/'}>{t('footer.interestBasedAds')}</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer;
